export default __webpack_public_path__ + "a39f18e.png";